(function () {
  'use strict';

  // Mobile nav
  var toggle = document.querySelector('[data-nav-toggle]');
  var header = document.querySelector('[data-header]');
  if (toggle && header) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.querySelectorAll('.main-nav a').forEach(function (a) {
      a.addEventListener('click', function () {
        header.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  // Click-to-load YouTube (keeps the page fast)
  document.querySelectorAll('[data-video-play]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var frame = btn.closest('[data-youtube]');
      var id = frame.getAttribute('data-youtube');
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1';
      iframe.title = 'EZFeeder video';
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      frame.innerHTML = '';
      frame.appendChild(iframe);
    });
  });

  // Product gallery
  var gallery = document.querySelector('[data-gallery]');
  function showSlide(index) {
    if (!gallery) return;
    gallery.querySelectorAll('[data-slide]').forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-slide') === String(index));
    });
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(index));
    });
  }
  if (gallery) {
    gallery.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () { showSlide(t.getAttribute('data-thumb')); });
    });
  }

  // Variant selection
  var form = document.querySelector('[data-product-form]');
  var jsonEl = document.querySelector('[data-product-json]');
  if (form && jsonEl) {
    var product = JSON.parse(jsonEl.textContent);
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-button]');
    var priceEl = document.querySelector('[data-price] .price');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var money = function (cents) {
      var n = cents / 100;
      return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2));
    };

    form.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = [];
        form.querySelectorAll('.option-group').forEach(function (group, i) {
          var checked = group.querySelector('input:checked');
          selected[i] = checked ? checked.value : null;
          var label = form.querySelector('[data-option-label="' + i + '"]');
          if (label && checked) label.textContent = checked.value;
        });
        var variant = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (stickyPrice) stickyPrice.textContent = money(variant.price);
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (variant.featured_media) {
          var slide = gallery && gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
          if (slide) showSlide(slide.getAttribute('data-slide'));
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      });
    });

    // Quantity
    form.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = form.querySelector('input[name="quantity"]');
        var v = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
        q.value = v;
      });
    });

    // Sticky add-to-cart bar
    var sticky = document.querySelector('[data-sticky-buy]');
    if (sticky && 'IntersectionObserver' in window) {
      sticky.hidden = false;
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(addBtn);
      sticky.querySelector('[data-sticky-add]').addEventListener('click', function () {
        if (addBtn.disabled) return;
        form.requestSubmit ? form.requestSubmit(addBtn) : addBtn.click();
      });
    }
  }

  // Gentle reveal on scroll
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var targets = document.querySelectorAll('.feature, .step, .compare-card, .photo-tile, .faq-item, .story-photo, .steps-photo, .video-frame, .table-wrap');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach(function (t) { t.classList.add('reveal'); io.observe(t); });
  }
})();
